import EmblaCarousel from 'embla-carousel'

const emblaCarousel = {
	listener: null,
	instances: new WeakMap(),
	controls: new WeakMap(),

	directive: {
		mounted(el) {
			const instance = EmblaCarousel(el, {
				align: 'start',
				startIndex: 0,
				containScroll: 'keepSnaps',
			});

			const wrapper = el.closest('.embla');
			const prevButton = wrapper ? wrapper.querySelector('.embla__prev') : null;
			const nextButton = wrapper ? wrapper.querySelector('.embla__next') : null;

			const updateButtons = () => {
				if (prevButton) prevButton.disabled = !instance.canScrollPrev();
				if (nextButton) nextButton.disabled = !instance.canScrollNext();
			};

			const onPrevClick = (event) => {
				event.preventDefault();
				instance.scrollPrev();
			};

			const onNextClick = (event) => {
				event.preventDefault();
				instance.scrollNext();
			};

			if (prevButton) prevButton.addEventListener('click', onPrevClick);
			if (nextButton) nextButton.addEventListener('click', onNextClick);

			instance.on('init', updateButtons);
			instance.on('select', updateButtons);
			instance.on('reInit', updateButtons);
			updateButtons();

			emblaCarousel.controls.set(el, {
				prevButton,
				nextButton,
				onPrevClick,
				onNextClick,
			});

			emblaCarousel.instances.set(el, instance);
			window.ec = instance;
		},

		unmounted(el) {
			const instance = emblaCarousel.instances.get(el);
			const controls = emblaCarousel.controls.get(el);

			if (controls) {
				if (controls.prevButton) controls.prevButton.removeEventListener('click', controls.onPrevClick);
				if (controls.nextButton) controls.nextButton.removeEventListener('click', controls.onNextClick);
				emblaCarousel.controls.delete(el);
			}

			if (instance) {
				instance.destroy();
				emblaCarousel.instances.delete(el);
			}
		}
	},

	plugin: {
		install(app) {
			app.directive('embla-carousel', emblaCarousel.directive);
		},
	},
};

export default emblaCarousel;
